import { render } from "./DefinitionOfEffect.vue?vue&type=template&id=4ee61dcc&scoped=true"
import script from "./DefinitionOfEffect.vue?vue&type=script&lang=js"
export * from "./DefinitionOfEffect.vue?vue&type=script&lang=js"

import "./DefinitionOfEffect.vue?vue&type=style&index=0&id=4ee61dcc&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ee61dcc"]])

export default __exports__